// extracted by mini-css-extract-plugin
export default {"menuBlock":"yF-z","title":"zF-z","nav":"AF-z","flexCell":"BF-z","facetLink":"CF-z"};